module.exports = __webpack_public_path__ + "img/mc.7b1e3023.png";